import { render, staticRenderFns } from "./ViewClientDetails.vue?vue&type=template&id=d745b87c&scoped=true"
import script from "./ViewClientDetails.vue?vue&type=script&lang=js"
export * from "./ViewClientDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewClientDetails.vue?vue&type=style&index=0&id=d745b87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d745b87c",
  null
  
)

export default component.exports